export const UPLOAD_SET_CANCEL_TOKEN_SOURCE = 'UPLOAD_SET_CANCEL_TOKEN_SOURCE';
export const UPLOAD_CANCEL = 'UPLOAD_CANCEL';
export const UPLOAD_DONE = 'UPLOAD_DONE';
